import { confirmation, error } from '@/utils/alert'
import { resource as httpApi, localHttp as httpExternal } from '@/plugins/http'
import { get, isEmpty } from 'lodash'

export default {
  existsRegister (path, callback, external = false) {
    const http = (external) ? httpExternal : httpApi('')
    http.get(path)
      .then(({ data, meta }) => {
        if (typeof callback === 'function') {
          return callback(data, meta)
        }
        return data.exists
      })
  },
  existsRegisterExternal (resources, title, route, callback) {
    return this.existsRegister(resources, title, route, callback, true)
  },
  afterCreated (data, item) {
    this.afterSave(data, item)
  },
  afterSave (data, item) {
    return this.$router.push({ name: this.getRouterIndex })
  },
  afterUpdated (data, item) {
    this.afterSave(data, item)
  },
  afterPrepareShow () {
  },
  doSave () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }
    const item = this.prepareSave({...this[this.entity]})

    if (!this.beforeSave(item)) {
      return
    }

    this.$resource.save(item)
      .then(({data}) => {
        this.errors = {}
        const after = this.isCreate ? 'Created' : 'Updated'

        this['after' + after](data, item)
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
  },
  afterFailure ({data, meta}) {
    if (isEmpty(get(meta, 'message', ''))) {
      error('Erro ao processar informações!')
    }
    this.$toast.error(get(meta, 'message', ''))
    // warning(get(meta, 'message', ''))
  },
  doDelete (item) {
    this.currentEntity = item
    const message = {
      label: null,
      title: null,
      message: null,
      cancel: null,
      ...this.getMessageConfirmation
    }

    confirmation(confirm => {
      if (!confirm) {
        return
      }

      this.doDeleteWithoutConfirmation(item)
    }, message.message, message.title, message.label, message.cancel)
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    if (!this.beforeDelete(entity)) {

    }

    this.$resource.delete(entity.id)
      .then(({data}) => {
        this.afterDelete(entity, data)
      })
  },
  afterDelete (entity, itemDeleted) {
    const index = this[this.entities].indexOf(entity)
    this[this.entities].splice(index, 1)
  },
  beforeDelete (item) {
    return true
  },
  beforeSave (item) {
    return true
  },
  prepareSave (item) {
    return item
  },
  prepareShow (item) {
    return item
  }
}



// WEBPACK FOOTER //
// ./src/crud/resources/methods.js